module.exports = __webpack_public_path__ + "img/home-img-blue.97fa2637.png";